export default {
    components: [{
            component_name: "user-login",
            component_property: require("./components/sessions/UserLogin.vue").default,
            is_enabled: true,
        },
        {
            component_name: "user-groups",
            component_property: require("./components/userGroups/UserGroups.vue").default,
            is_enabled: true,
        },
    ],
};